import { NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

const navItems = [
  { to: '/', icon: '🏠', label: 'HQ', end: true },
  { to: '/workouts', icon: '💪', label: 'Workouts' },
  { to: '/classes', icon: '📅', label: 'Classes' },
  { to: '/progress', icon: '📊', label: 'Progress' },
  { to: '/quests', icon: '⚔️', label: 'Quests' },
  { to: '/leaderboard', icon: '🏆', label: 'Rankings' },
  { to: '/billing', icon: '💎', label: 'Plans' },
  { to: '/profile', icon: '👤', label: 'Profile' },
]

export default function Layout() {
  const { user, logout } = useAuth()

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <h1>$5 FITNESS</h1>
          {user && (
            <div style={{ marginTop: '0.75rem', fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
              <span style={{ color: 'var(--gold)' }}>{user.displayName || user.firstName || 'Player'}</span>
              <br />
              <span className="font-pixel" style={{ fontSize: '0.5rem' }}>
                LVL {user.level} · {user.xp} XP
              </span>
            </div>
          )}
        </div>
        <nav className="sidebar-nav">
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div style={{ padding: '0 0.75rem', marginTop: 'auto' }}>
          <button onClick={logout} className="nav-item" style={{ color: 'var(--accent-red)' }}>
            <span className="nav-icon">🚪</span>
            <span>Logout</span>
          </button>
        </div>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  )
}
